var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFatalErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff4300;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.47,21.94h.12a3.24,3.24,0,1,0,0-6.47h-.12a3.24,3.24,0,1,0,0,6.47Zm-15.23,0h.13a3.24,3.24,0,0,0,0-6.47h-.13a3.24,3.24,0,0,0,0,6.47ZM25,0A25,25,0,1,0,50,25,25,25,0,0,0,25,0Zm0,46.61A21.61,21.61,0,1,1,46.61,25,21.64,21.64,0,0,1,25,46.61Zm-9.07-8.49A12.81,12.81,0,0,1,25,34a12.81,12.81,0,0,1,9.07,4.09,22,22,0,0,0,2.48-1.36l.09-.14c-3.14-3.72-7.2-6-11.64-6s-8.5,2.26-11.64,6l.09.14A22,22,0,0,0,15.93,38.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFatalErrorIcon);
export default __webpack_public_path__ + "static/media/fatal-error-icon.3ad6f5972a2919b29d03bb8fdbf4e43d.svg";
export { ForwardRef as ReactComponent };